import React from 'react';

const ProductDetail = () => {
  return (
    <h1>
      <p>Detail</p>
      <p>Number of Pages : 190</p>
      <p>Data of Issue : 12 January 2012</p>
      <p>ISBN : 128419264382</p>
      <p>Language : English</p>
      <p>Publisher : Erlangga</p>
      <p>Weight : 0,2 kilos</p>
      <p>Dimension : 13cm x 19cm</p>
    </h1>
  );
};

export default ProductDetail;
